import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ExternalLink } from "lucide-react";
import { siteQueries } from "@/lib/queries";

export const Route = createFileRoute("/_authed/sites/$siteId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(siteQueries.detail(params.siteId)),
  component: SiteShell,
});

function SiteShell() {
  const { siteId } = Route.useParams();
  const { data: site } = useSuspenseQuery(siteQueries.detail(siteId));
  const liveUrl = `https://${site.slug}.on.sandbar.cloud`;

  return (
    <div>
      <header className="mb-8">
        <h1 className="mb-1 font-display text-2xl font-semibold text-(--c-text)">{site.name}</h1>
        <a
          href={liveUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 font-mono text-sm text-(--c-text-3) no-underline transition-colors hover:text-(--c-text-2)"
        >
          {site.slug}.on.sandbar.cloud
          <ExternalLink className="size-3" />
        </a>
      </header>
      <Outlet />
    </div>
  );
}
